import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import fullLogoImg from 'shared/assets/images/fullLogo.png'
import { Typography } from 'shared/ui'
import { ModalLargeIcon } from 'shared/ui/Icon/ModalLargeIcon/ModalLargeIcon'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { getAriaLabel, getCDNAssetURL } from 'shared/lib'
import { LINK_WEBSITE } from 'shared/constants/links'
import { PasswordChangeForcePageStore } from 'pages/auth/pages/passwordChangeForce/store/passwordChangeForcePageStore'
import {
  ProviderPasswordChangeForcePage,
  usePasswordChangeForcePageContext,
} from 'pages/auth/pages/passwordChangeForce/context/passwordChangeForceContext'
import { PasswordChangeForceForm } from 'pages/auth/pages/passwordChangeForce/ui/PasswordChangeForceForm/PasswordChangeForceForm'
import { SuccessForm } from 'pages/auth/pages/passwordChangeForce/ui/SuccessForm/SuccessForm'
import styles from './styles.module.scss'

const PasswordChangeForcePageContent = observer(() => {
  const store = usePasswordChangeForcePageContext()

  return (
    <div className={styles.wrap}>
      <div className={styles.content}>
        <div className={styles.logoWrap}>
          <a href={LINK_WEBSITE} target='_blank' rel='noreferrer'>
            <img className={styles.logo} alt='logo' src={getCDNAssetURL(fullLogoImg)} />
          </a>
        </div>

        <div className={styles.main}>
          {store.success ? (
            <SuccessForm />
          ) : (
            <>
              <div className={styles.iconWrap}>
                <ModalLargeIcon type={ModalTypeList.LOCK} />
              </div>

              <div className={styles.textWrap}>
                <Typography
                  ariaLabel={getAriaLabel('passwordChangeForce-title')}
                  variant={'heading-lg'}
                  color={'var(--content-primary-primary)'}
                >
                  Mandatory password change is required
                </Typography>

                <Typography
                  ariaLabel={getAriaLabel('passwordChangeForce-subtitle')}
                  variant={'body-lg-regular'}
                  color={'var(--content-primary-tertiary)'}
                >
                  Click the button below to receive an email with the password change link
                </Typography>
              </div>
            </>
          )}

          <PasswordChangeForceForm store={store} />
        </div>
      </div>
    </div>
  )
})

export const PasswordChangeForcePage = () => {
  const store = useMemo(() => new PasswordChangeForcePageStore(), [])

  return (
    <ProviderPasswordChangeForcePage value={store}>
      <PasswordChangeForcePageContent />
    </ProviderPasswordChangeForcePage>
  )
}

export default PasswordChangeForcePage
